import { render, staticRenderFns } from "./salesReturn.vue?vue&type=template&id=6ed19d59&scoped=true"
import script from "./salesReturn.vue?vue&type=script&lang=js"
export * from "./salesReturn.vue?vue&type=script&lang=js"
import style0 from "./salesReturn.vue?vue&type=style&index=0&id=6ed19d59&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed19d59",
  null
  
)

export default component.exports